module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/sophia-hutchison-f298c4f2a32897343c85c0b397b36297.jpg";